<template>
<el-row type="flex" class="bg" justify="center" align="middle">
  <el-col :xs="18" :sm="14" :md="10" :lg="6">
    <img src="./assets/mrclogo.svg" alt="MRC Asia" class="logo" style="width: 100%;">
    <p></p>
    <el-form label-position="top" :model="user" v-if="!isIe && !user.isMFA" :rules="rules" ref="loginForm" :disabled='isLocked'>
      <el-form-item label="Email" prop="userid">
        <el-input v-model="user.userid" type="email"></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input v-model="user.password" type="password" auto-complete="off"></el-input>
        <a href="/sign/forget">Forget Password?</a>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('loginForm')" style="width:100%;" type="danger" plain :disabled='isLocked'>Log in</el-button>
      </el-form-item>
    </el-form>
    <el-form label-position="top" :model="user" v-if="!isIe && user.isMFA" ref="loginOTPForm" :disabled='isLocked'>
      <el-form-item label="One_Time Password" prop="userKeyInOTP">
        <el-input v-model="user.userKeyInOTP" type="text" inputmode="numeric" style="width: 240px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitOTPForm('loginOTPForm')" style="width:240px" type="danger" plain :disabled='isLocked'>Verify</el-button>
        <el-button @click="resendOTPForm('loginOTPForm')" style="width:140px" type="danger" plain :disabled='isLocked' v-show='isResendLocked'>Resend OTP</el-button>
      </el-form-item>
      <el-form-item>
        <a v-show='!isResendLocked' href="/sign">Go back to Login</a>
      </el-form-item>
    </el-form>
    <div class="warning" v-if="isIe">
      <h2>Internet Explorer is not supported. Please use a modern browser like Google Chrome, Firefox or Microsoft Edge.</h2>
    </div>
    <div class="warning" v-if="isLocked">
      <h3>You’ve reached the maximum logon attempts. Your account has been locked. Please contact (65) 6235 2852 for more information.</h3>
    </div>
  </el-col>
</el-row>
</template>

<script>
import axios from 'axios';
import util from './util';

export default {
  name: 'app',
  data() {
    return {
      isIe: false,
      isLocked: false,
      isResendLocked: true,
      user: {
        userid: '',
        password: '',
        isMFA: false,
        userKeyInOTP: '',
      },
      rules: {
        userid: [{
            required: true,
            message: 'Please input email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: 'blur,change',
          },
        ],
        password: [{
          required: true,
          message: 'Please enter your password',
          trigger: 'blur',
        }],
      },
      rulesOTP: {
        userKeyInOTP: [{
          required: true,
          message: 'Please enter OTP',
          trigger: 'blur',
        }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let source = util.queryString.source;
          if (!source) {
            source = '/';
          }
          this.user.autoLogin = false;
          axios.post(`/sign/api/signin?source=${source}`, this.user)
            .then((response) => {
              if (response.data[0] === true) {
                window.location.href = '/sign/auth/cp?info=expired';
              } else if (response.data[1] === true) {
                this.user.isMFA = true;
              } else {
                window.location.href = source;
              }
            })
            .catch((err) => {
              if (err.response.status > 500) {
                this.$message({
                  type: 'error',
                  message: 'Error connecting. Please try again...',
                });
                return;
              }
              if (err.response.data === 'max attempt') {
                this.isLocked = true;
                this.$message({
                  type: 'error',
                  message: 'You’ve reached the maximum logon attempts.',
                });
              } else {
                this.$message({
                  type: 'error',
                  message: err.response.data,
                });
              }
            });
          return true;
        }
        return false;
      });
    },
    resendOTPForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let source = util.queryString.source;
          if (!source) {
            source = '/';
          }
          this.user.autoLogin = false;
          axios.post('/sign/api/signin/otp', this.user)
            .then((response) => {
              if (response.data[1] === true) {
                this.user.isMFA = true;
                this.isResendLocked = false;
              }
            })
            .catch((err) => {
              if (err.response.status > 500) {
                this.$message({
                  type: 'error',
                  message: 'Error connecting. Please try again...',
                });
                return;
              }
              if (err.response.data === 'wrong otp') {
                this.$message({
                  type: 'error',
                  message: 'OTP doesnt match.',
                });
              } else if (err.response.data === 'otp expired') {
                this.$message({
                  type: 'error',
                  message: 'OTP is expired.',
                });
              } else {
                this.$message({
                  type: 'error',
                  message: err.response.data,
                });
              }
            });
          return true;
        }
        return false;
      });
    },
    submitOTPForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let source = util.queryString.source;
          if (!source) {
            source = '/';
          }
          this.user.autoLogin = false;
          axios.post('/sign/api/signin/verify', this.user)
            .then((response) => {
              if (response.data === true) {
                window.location.href = source;
              }
            })
            .catch((err) => {
              if (err.response.status > 500) {
                this.$message({
                  type: 'error',
                  message: 'Error connecting. Please try again...',
                });
                return;
              }
              if (err.response.data === 'wrong otp') {
                this.$message({
                  type: 'error',
                  message: 'OTP doesnt match.',
                });
              } else if (err.response.data === 'otp expired') {
                this.$message({
                  type: 'error',
                  message: 'OTP is expired.',
                });
              } else {
                this.$message({
                  type: 'error',
                  message: err.response.data,
                });
              }
            });
          return true;
        }
        return false;
      });
    },
  },
  mounted() {
    if (util.detectIE()) {
      this.isIe = true;
    }
    this.$el.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        this.submitForm('loginForm');
      }
    });
  },
  created() {
    const username = util.queryString.u;
    const userpassword = util.queryString.p;
    if (username && userpassword) {
      this.user.userid = username;
      this.user.password = userpassword;
      this.user.autoLogin = true;
      let source = util.queryString.source;
      if (!source) {
        source = '/';
      }
      axios.post(`/sign/api/signin?source=${source}`, this.user)
        .then((response) => {
          if (response.data[0] === true) {
            window.location.href = '/sign/auth/cp?info=expired';
          } else if (response.data[1] === true) {
            this.user.isMFA = true;
          } else {
            window.location.href = source;
          }
        })
        .catch((err) => {
          if (err.response.status > 500) {
            this.$message({
              type: 'error',
              message: 'Error connecting. Please try again...',
            });
            return;
          }
          if (err.response.data === 'max attempt') {
            this.isLocked = true;
            this.$message({
              type: 'error',
              message: 'You’ve reached the maximum logon attempts.',
            });
          } else {
            this.$message({
              type: 'error',
              message: err.response.data,
            });
          }
        });
    }
  },
};
</script>

<style>
.bg {
  font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
  left: 0;
  top: 0;
  background: rgb(255, 255, 255);
  background: linear-gradient(rgb(242, 255, 245), rgb(235, 242, 255));
  height: 100%;
  width: 100%;
  position: fixed;
  margin: 0;
}

.warning {
  color: red;
  margin: 20px 0 0 0;
}

input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
               -webkit-appearance: none;
                margin: 0;
        }
 
        input[type=number] {
            -moz-appearance: textfield;
        }
</style>



// WEBPACK FOOTER //
// App.vue?b681a8b4